import BigNum from "../model/math/BigNum";
import BigNumMath from "../model/math/BigNumMath";

export default class GameNumberFormat {
    constructor() {
        /**
         * @constant
         * @type {BigNum}
         */
        this.working = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.hundredThousand = new BigNum(100000);

        /**
         * @constant
         * @type {Object}
         */
        this.noDecimalPlacesOptions = { maximumFractionDigits: 0 };
    }

    /**
     * @param {number} number 
     */
    formatNumber(number) {
        if (number < 100000) {
            return this.formatSmallNumber(number);
        }

        BigNumMath.fromNumber(this.working, number);
        return this.bigNumToGameString(this.working);
    }

    /**
     * @param {BigNum} bigNum
     * @returns {string}
     */
    formatBigNum(bigNum) {
        if (bigNum.lessThan(this.hundredThousand)) {
            return this.formatSmallNumber(bigNum.toNumber());
        }

        return this.bigNumToGameString(bigNum);
    }

    /**
     * @private
     * @param {number} number Must be less than 100,000.
     * @returns {string}
     */
    formatSmallNumber(number) {
        if (number < 100) {
            if (Number.isInteger(number)) {
                return number.toFixed(0);
            }
            else {
                return number.toFixed(2);
            }
        } 
        else if (number < 1000) {
            if (Number.isInteger(number)) {
                return number.toFixed(0);
            }
            else {
                return number.toFixed(1);
            }
        } 

        return number.toLocaleString(undefined, this.noDecimalPlacesOptions);
    }

    /**
     * @private
     * @param {ManExp} value
     * @returns {string}
     */
    bigNumToGameString(value) {
        if (typeof value === "number") {
            console.log('BigNumMath.toGameString() passed number instead of BigNum');
            console.trace();
        }

        if (isNaN(value.m) || isNaN(value.e)) {
            return "NaN";
        }

        // if (value.e >= EXP_LIMIT) {
        //     return value.m > 0 ? "Infinity" : "-Infinity";
        // }

        // if (value.e <= -EXP_LIMIT || value.m === 0) {
        //     return "0";
        // }

        if (value.e < 10) {
            return value.m.toFixed(3) + 'E' + value.e;
        }
        else if (value.e < 100) {
            return value.m.toFixed(2) + 'E' + value.e;
        }
        else {
            return value.m.toFixed(1) + 'E' + value.e;
        }
    }

}